import React from "react"
import { Menu } from "@mantine/core"

import { Button, Icon } from "@/components"
import { useStyles } from "./QuickActionsDropdown.styles"

import { QuorumTheme } from "app/static/frontend/design-constants"

export const QuickActionsDropdown = ({ quickActionsOptions }) => {
    const { classes } = useStyles({
        loggedInAsUser: Boolean(Userdata.logged_in_as_user) || Boolean(Userdata.logged_in_as_user_from_regular_user),
    })

    const menuOptions = quickActionsOptions

    const renderItems = () => {
        if (!menuOptions || menuOptions.length === 0) {
            return (
                <div className={classes.noActionContainer}>
                    <Icon iconFamily="q" icon="bolt-slash" size="lg" color={QuorumTheme.colors.violet[5]} />

                    <div className={classes.noActionTitleText}>Nothing to show here</div>
                    <div className={classes.noActionSmallText}>
                        You have no quick actions currently enabled for you.
                    </div>
                </div>
            )
        }
        return menuOptions.map((item) => {
            const SegueLinkComponent = item.segueLinkComponent

            return (
                <SegueLinkComponent
                    to={item.segueLinkProps.to}
                    key={item.text}
                    optionalPreSegueFunction={item.segueLinkProps.optionalPreSegueFunction}
                >
                    <Menu.Item className={classes.itemContainer}>
                        <Icon icon={item.icon} iconFamily={item.iconFamily} className={classes.itemIcon} />
                        <span>{item.text} </span>
                    </Menu.Item>
                </SegueLinkComponent>
            )
        })
    }

    return (
        <Menu position="bottom-end" offset={5}>
            <Menu.Target>
                <Button className={classes.quickActionButton}>
                    <Icon icon="plus" className={classes.buttonIcon} />
                    <span className={classes.buttonText}>New</span>
                </Button>
            </Menu.Target>

            <Menu.Dropdown role="menu" className={classes.dropdown}>
                {renderItems()}
            </Menu.Dropdown>
        </Menu>
    )
}
